import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import logger from 'logger';
import ApiService from 'services/ApiService/ApiService';
import { ROSTER_URL } from 'pages/StudioRoster/Api';
import { usernameOrImpersonate } from 'utils/helpers';

import { PERFORMER_INFO_URL } from './Api';


const PERFORMER_INFO = 'cam4/studio/PERFORMER_INFO';
const PERFORMER_STUDIO_DATA = 'cam4/studio/PERFORMER_STUDIO_DATA';

const initialState = Immutable.fromJS({
  performerInfo: [],
  performerStudioData: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PERFORMER_INFO:
      return state.set('performerInfo', Immutable.fromJS(action.performerInfo));

    case PERFORMER_STUDIO_DATA:
      return state.set('performerStudioData', Immutable.fromJS(action.performerStudioData));

    default:
      return state;
  }
}

export const NAME = 'performerStudioInfo';

const performerInfo = (state) => state[NAME].get('performerInfo');
const performerStudioData = (state) => state[NAME].get('performerStudioData');

export const selector = createStructuredSelector({
  performerInfo,
  performerStudioData,
});

function displayPerformerInfo(res) {
  return {
    type: PERFORMER_INFO,
    performerInfo: res.data,
  };
}

function displayPerformerStudioData(data) {
  return {
    type: PERFORMER_STUDIO_DATA,
    performerStudioData: data,
  };
}

function getPerformerInfo(performerName) {
  return (dispatch) => {
    const url = ApiService.substitute(PERFORMER_INFO_URL, { performerName: usernameOrImpersonate(performerName) });
    ApiService.get(url).then((res) => {
      dispatch(displayPerformerInfo(res));
    });
  };
}

function getPerformerStudioData(studioOwnerName, performerName) {
  return (dispatch) => {
    const url = encodeURI(ApiService.substitute(ROSTER_URL, { studioOwnerName }));
    ApiService.get(url)
      .then((res) => {
        const data = res.data.find(({ username }) => username === performerName);
        dispatch(displayPerformerStudioData(data));
      })
      .catch((error) => logger.error(error));
  };
}


export const actionCreators = {
  getPerformerInfo,
  getPerformerStudioData,
};
